if (!customElements.get('m-product-size-chart')) {
  customElements.define(
    'm-product-size-chart',
    class MProductSizeChart extends HTMLElement {
      connectedCallback() {
        this.modal = this.querySelector('[data-size-chart-modal]');
        this.openButton = this.querySelector('[data-size-chart-open]');

        if (!this.modal || !this.openButton) return;

        this.portalModal();
        this.bindEvents();
      }

      portalModal() {
        if (this.modal.parentElement !== document.body) {
          document.body.appendChild(this.modal);
        }
      }

      bindEvents() {
        this.openButton.addEventListener('click', () => this.open());

        this.modal.querySelectorAll('[data-size-chart-close]').forEach((el) => {
          el.addEventListener('click', () => this.close());
        });

        this.handleKeydown = (event) => {
          if (event.key === 'Escape') this.close();
        };
      }

      open() {
        if (this.openButton.disabled) return;

        this.portalModal();
        this.modal.hidden = false;
        document.body.classList.add('m-product-size-chart-open');
        document.addEventListener('keydown', this.handleKeydown);
      }

      close() {
        this.modal.hidden = true;
        document.body.classList.remove('m-product-size-chart-open');
        document.removeEventListener('keydown', this.handleKeydown);
        this.openButton.focus();
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.handleKeydown);
        document.body.classList.remove('m-product-size-chart-open');

        if (this.modal?.parentElement === document.body) {
          this.appendChild(this.modal);
        }
      }
    }
  );
}
